import Entity from './../entity'
import TransferOrderLine from './../transfer-orders/transfer-order-line'

export default class TransferOrder extends Entity<number>{
    toReqCode:string;
    transferDate:Date;
    shippingServiceCode:string;
    toReqNote :string;
    isNoPack:boolean;
    assetTypeName :string;
    conditionTypeName:string;
    srcWarehouseDisplayName:string;
    dstWarehouseDisplayName:string;
    tplDisplayName:string;
    clientDisplayName:string;
    outStatusName:string;
    inStatusName:string;
    inputChannelName:string;
    creatorUserName: string;
    creationTime: Date;
    shippingFullAddress:string;
    declareOverShort :boolean;
    poId:number;
    outStatusCode:string;
    inStatusCode:string;
    canceledNote:string;
    canceledName: string;
    canceledDate: Date;
    shippingServiceName:string;
    items: Array<TransferOrderLine>;
}